<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { api } from '../../../stores/api';
    import { get } from 'svelte/store';

    import { TacticalPlanRuleApi } from './TacticalPlanRuleApi';
    import type { TacticalPlanRule } from './TacticalPlanRule';
    import IconAutoRenew from '../../shared/Icons/IconAutoRenew.svelte';
    import WhiteColor from '../../shared/WhiteColor.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import Opacity from '../../shared/Opacity.svelte';

    export let rule: TacticalPlanRule;

    let scale = 0.6;
    let spin: boolean = false;

    let mode: 'icon' | 'checkbox' = 'checkbox';

    function getTitle() {
        return rule.getAutoConfirm() ? $_('auto_confirm_rule_on') : $_('auto_confirm_rule_off');
    }

    function toggleAutoConfirm() {
        let ruleId = rule.getId();
        if (ruleId === null) {
            console.warn('Rule id is null');
            return;
        }
        spin = true;
        let newValue = !rule.getAutoConfirm();
        rule.setAutoConfirm(newValue);
        rule = rule;
        TacticalPlanRuleApi.patch(get(api), ruleId, '/auto_confirm', newValue)
            .then(() => {
                spin = false;
            })
            .catch(err => {
                console.error(err);
            })
            .finally(() => {
                spin = false;
            });
    }
</script>

{#if mode === 'icon'}
    {#if rule.getAutoConfirm()}
        <div class="icon-rule-auto-confirm icon-rule-auto-confirm--on">
            <WhiteColor>
                <IconAutoRenew {scale} title={getTitle()} {spin} on:click={toggleAutoConfirm} />
            </WhiteColor>
        </div>
    {:else}
        <div class="icon-rule-auto-confirm icon-rule-auto-confirm--off">
            <Opacity opacity={1}>
                <IconAutoRenew {scale} title={getTitle()} {spin} on:click={toggleAutoConfirm} />
            </Opacity>
        </div>
    {/if}
{/if}

{#if mode === 'checkbox'}
    <div class="checkbox-rule-auto-confirm checkbox-rule-auto-confirm--off">
        <Checkbox
            disabled={spin}
            checked={rule.getAutoConfirm()}
            label={$_('auto_confirm')}
            onChange={toggleAutoConfirm}
        />
    </div>
{/if}

<style>
    .icon-rule-auto-confirm {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        height: 22px;
        width: 22px;
        color: white;
        cursor: pointer;
    }
    .icon-rule-auto-confirm--on {
        background-color: #4caf50;
    }
    .icon-rule-auto-confirm--off {
        background-color: #e5e3e3;
    }

    .checkbox-rule-auto-confirm {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        height: 22px;
        cursor: pointer;
        padding: 0 0 0 10px;
    }
    .checkbox-rule-auto-confirm--off {
        background-color: #f7f7f7;
    }
</style>
